import GuidedSearchSingle from "../../../../../features/browse-search/components/GuidedSearchSingle";
import BaseCategoryPage from "../../../CategoryPage";

export const CategoryPage = (props) => (
  <BaseCategoryPage
    {...props}
    hideHeaderDescription
    topContent={<GuidedSearchSingle withCategoryDescription />}
  />
);

export default CategoryPage;
